import { createContext, useEffect, useState } from "react";
import { GetClientConfiguration } from "../api/client-configuration";
import Layout from "../components/Layout";
import Loader, { Types } from "../components/gdk/Loader";
import { useScriptLoader } from "../hooks/useScriptLoader";

export const ClientConfigurationContext = createContext();
const QUANTUM_METRICS_SCRIPT_ID = 'quantum-metrics-script';
const TAG_MANAGER_SCRIPT_ID = 'tag-manager-script';
const QUANTUM_METRICS_SCRIPT_CLASS = 'optanon-category-C02';
const QUANTUM_METRICS_SCRIPT_TYPE = 'text/plain';

export function ClientConfigurationContextProvider({ children }) {
    const [clientConfiguration, setClientConfiguration] = useState();

    useEffect(() => {
        GetClientConfiguration(response => {
            setClientConfiguration(response);
        });
    }, []);

    const quantumMetricsUrl = clientConfiguration?.enableQuantumMetrics && clientConfiguration?.quantumMetricsUrl != null && clientConfiguration?.quantumMetricsUrl !== ""
        ? clientConfiguration?.quantumMetricsUrl
        : null;

    const tagManagerUrl = clientConfiguration?.enableTagManager && clientConfiguration?.tagManagerUrl != null && clientConfiguration?.tagManagerUrl !== ""
        ? clientConfiguration?.tagManagerUrl
        : null;

    useScriptLoader(quantumMetricsUrl, QUANTUM_METRICS_SCRIPT_ID, QUANTUM_METRICS_SCRIPT_CLASS, QUANTUM_METRICS_SCRIPT_TYPE);
    useScriptLoader(tagManagerUrl, TAG_MANAGER_SCRIPT_ID);

    return (
        <ClientConfigurationContext.Provider value={clientConfiguration}>
            {!clientConfiguration &&
                <Loader type={Types.Section} />
            }
            {clientConfiguration?.masterSwitch === false &&
                <Layout>
                    <div className="container margin-top">
                        <h3>Maintenance</h3>
                        <p>
                            The system is down for maintenance. Please check again later.
                        </p>
                    </div>
                </Layout>
            }
            {clientConfiguration?.masterSwitch === true &&
                <>{children}</>
            }
        </ClientConfigurationContext.Provider>
    );
}